<template>
    <div class="container-fluid h-100">
        <div class="content-registerc-class" id="content-registerc" title="códigos Havoline MotoClub" alt="códigos Havoline MotoClub">
            <div
                class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 pblr">
                <div class="col-12 col-md-8 col-lg-8 col-xl-8 col-sm-6">
                    <h1 class="participa">¿CÓMO REGISTRAR CÓDIGOS?</h1>
                    <p class="carrera">Únete al club y aprende cómo usar tus códigos para ganar increíbles beneficios</p>
                    <div
                        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center pt-3">
                        <div class="col-8 col-md-3 col-lg-3 col-xl-3 col-sm-3 ">
                            <img class="img-etiqueta" src="../../assets/icon/Recurso 4.png"
                                alt="Compra productos Havoline 4T*">
                            <p class="etiqueta">Compra productos Havoline 4T*</p>
                        </div>
                        <div class="col-8 col-md-3 col-lg-3 col-xl-3 col-sm-3">
                            <img alt="Compra productos Havoline 4T*" class="img-etiqueta" src="../../assets/icon/Recurso 6.png">
                            <p class="etiqueta">Levanta la etiqueta o raspa el sticker.</p>
                        </div>
                        <div class="col-8 col-md-3 col-lg-3 col-xl-3 col-sm-3">
                            <img alt="Compra productos Havoline 4T*" class="img-etiqueta" src="../../assets/icon/Recurso 3.png">
                            <p class="etiqueta">Ingresa en la página web del club</p>
                        </div>
                        <div class="col-8 col-md-3 col-lg-3 col-xl-3 col-sm-3">
                            <img alt="Compra productos Havoline 4T*" class="img-etiqueta" src="../../assets/icon/Recurso 1.png">
                            <p class="etiqueta">Escribe tus códigos en tu perfil.</p>
                        </div>
                    </div>
                    <div
                        class="row pt-3 justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 section2">
                        <div class="col-12 col-md-12 col-lg-9 col-xl-9 col-sm-9">
                            <p class="oportunidades">ENTRE MÁS CÓDIGOS REGISTRES,</p>
                            <p class="oportunidades">MÁS BENEFICIOS PUEDES REDIRMIR.</p>
                            <small class="small-size font-weight-bold">*Encuentra los códigos en los productos Havoline 4T y complementarios para motos.</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    methods: {
      coljuegos(){
        window.open('https://promohavoline.com/resolucion20201000007984_23032020.pdf', '_blank');                
      },
      clienteHavoline(){
        window.open('https://promohavoline.com/comunicadoFinalClientes.pdf', '_blank');                
      },
    },
    mounted(){
    },
  }
</script>

<style>
.img-etiqueta {
    width: 100px;
    height: 100px;
}
.participa {
    font-size: 50px;
    font-family: 'Gotham-UltraItalic', sans-serif;
    padding-bottom: 0%;
}
.carrera {
    font-size: 18px;
    font-family: "GothamBoldItalic", sans-serif;
}
.etiqueta {
    padding-top: 10px;
    font-family: "GothamBoldItalic", sans-serif;
}
.small-size {
    font-family: "GothamBookItalic", sans-serif !important;
}
.actual {
    padding-left: 20%;
    font-family: "GothamBoldItalic", sans-serif;
}
.oportunidades {
    font-size: 18px;
    font-family: "GothamBoldItalic", sans-serif;
    margin-bottom: 0rem !important;
}
.text-1-promo {
    text-align: left;
    font-size: 24px;
    margin-bottom: 0rem !important;
    padding-left: 20%;
    font-family: "GothamBookItalic", sans-serif;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
.content-registerc-class {
    padding-top: 10%;
    padding-bottom: 10%;
    height: 100%;
}
#content-registerc {
    background-size: cover;
    background-image: url("./../../assets/img/04.jpg");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
}

@font-face {
    font-family: "ubuntu-bold";
    src: url("./../../assets/font/Ubuntu-Bold.ttf");
    font-display: swap;
}
@font-face {
    font-family: "Gotham-UltraItalic";
    src: url("./../../assets/font/Gotham-UltraItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBoldItalic";
    src: url("./../../assets/font/GothamBoldItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBookItalic";
    src: url("./../../assets/font/GothamBookItalic.ttf");
    font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
    .participa {
        font-size: 40px;
        /* padding-bottom: 4%; */
    }
    .carrera {
        font-size: 17px;
    }
    .content-registerc-class {
        padding-top: 35%;
        padding-bottom: 12%;
        height: 100%;
    }
    .actual {
        padding-left: 0%;
        font-size: 25px;
        text-align: center !important;

    }
    .text-1-promo {
        text-align: center;
        font-size: 20px;
        padding-left: 0%;
    }
}
</style>